var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0_57_3194)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_57_3194",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_57_3194",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_57_3194",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAOVBMVEVMaXH92DT92TX92DT91zP92Tf92DP91zP0tQP92DT5yB392DX92DX92DT//5D92Db92DX+51f+83LN4LA8AAAAE3RSTlMAWyLufw5B/P7Y/WydsP7K///+cGydyQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAP5JREFUeJyVU1uSwyAM460QCIjc/7A7ULYToGWm/oFEsjCyEeLHuK49Lgm5JWSWvMMdkYrbVUDc96YKBeJOVF8JhkBJxXxGrbCaREm3tt8FiJJWCWuVczJEkARTKohBOqe6kMleo2I9yv1aAe2zEcL2/2gk1E376Cm2ussOPaKRzuPlu9MT2hjncRxnN1X5hVHhw78ds9fEaOnX0464CJxxNukZOLH47cdT/NIJPShw6YcbjiA5j01oDr4VwDAR4quEf4/B+KlGdFIlTFWq3g4fgu+9GQdPtjxtrBDW1MECx/dRh4mxJ6lYRUanLjI/LuYyOU6/9NO1gt8/wR/iD0x5FjiGyKrCAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarImage);
export default __webpack_public_path__ + "static/media/star-image.7b524d2bd3db27dbf104df49c3a4ad11.svg";
export { ForwardRef as ReactComponent };